<script>
  import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Spinner
  } from "sveltestrap";
  import axios from "axios";
  import { onMount } from "svelte";

  export let open;
  export let toggle;
  export let name;
  export let deliverableId;
  export let jobId;
  let saving = false;

  onMount(() => {
    console.log(deliverableId);
  });

  function RemoveResource() {
    saving = true;
    var bodyFormData = new FormData();
    bodyFormData.set("jobId", jobId);
    axios({
      method: "post",
      url: "/jobboardapi/RemoveProjectManager",
      data: bodyFormData,
      headers: { "Content-Type": "multipart/form-data" }
    })
      .then(function(response) {
        saving = false;
        toggle();
        document.getElementById(deliverableId + "-edit").click();
      })
      .catch(function(response) {
        //handle error
        console.log(response);
      });
  }
</script>

<style>

</style>

<Modal isOpen={open} {toggle}>
  <ModalHeader {toggle}>Warning</ModalHeader>
  <ModalBody>Are you sure you want to remove {name}?</ModalBody>
  <ModalFooter>
    {#if saving}
      <Button color="primary" disabled>
        <Spinner size="sm" />
        Removing
      </Button>
    {:else}
      <Button color="primary" on:click={RemoveResource}>Yes</Button>
    {/if}
    <Button color="secondary" on:click={toggle}>No</Button>
  </ModalFooter>
</Modal>

